/**
 * Chromatic aberration shader: samples R/G/B at opposite-direction offsets.
 *
 * uTexture: source frame (staging canvas)
 * uResolution: staging size in CSS px
 * uOffset: offset magnitude in CSS pixels
 */
export const chromaticVertexShader = /* glsl */ `
attribute vec2 a_position;
attribute vec2 a_texCoord;
varying vec2 v_uv;
void main() {
  v_uv = a_texCoord;
  gl_Position = vec4(a_position, 0.0, 1.0);
}
`;

export const chromaticFragmentShader = /* glsl */ `
precision mediump float;
uniform sampler2D uTexture;
uniform vec2 uResolution;
uniform float uOffset;
varying vec2 v_uv;

void main() {
  vec2 dx = vec2(uOffset / uResolution.x, 0.0);
  float r = texture2D(uTexture, v_uv + dx).r;
  float g = texture2D(uTexture, v_uv).g;
  float b = texture2D(uTexture, v_uv - dx).b;
  float a = texture2D(uTexture, v_uv).a;
  gl_FragColor = vec4(r, g, b, a);
}
`;
